import useEventsService from "../../composables/useEventsService"
import _ from "lodash";

export default function() {
  return {
    vueinstance: null,

    configure(vueInstance) {
      this.vueInstance = vueInstance
    },

    /*
    * get non tiered charity list    
    */
    getNonTieredCharityList() {
      var self = this.vueInstance

      if (
        self.availableTiers.length === 0 ||
        self.searchText.length === 0
      )
        return []

      var list = self.availableTiers[0].Settings.map(
          tier =>
            self.charityResults.filter(
                c => !c.BeneficiaryTags || c.BeneficiaryTags.length == 0
            ) ||
            !c.BeneficiaryTags.find(bt => bt.TagId == tier.Entity.Value)
      )
  
      var finalList = []
      list.forEach(x => {
        x.forEach(y => {
          if (!finalList.find(z => z.BeneficiaryAccountId == y.BeneficiaryAccountId))
            finalList.push(y)
        })
      })
            
      return finalList
    },

    /*
    * get tiered charity list
    */
    getTieredCharityList() {              
      var self = this.vueInstance
                              
      if (self.availableTiers.length === 0)
        return [{ displayName: "", charities: self.charityResults }]

      // TODO: currenrly only supporting first type of tier and assuming its of type Beneficiary. This has to be adjusted
      // later for different tag types
      var list = self.availableTiers[0].Settings.map(tier => {
        return {
          displayName: tier.DisplayName,
          charities: self.charityResults.filter(
            c =>
              c.BeneficiaryTags &&
              c.BeneficiaryTags.length > 0 &&
              c.BeneficiaryTags.find(
                bt => bt.TagId == tier.Entity.Value
              )
          )
        }
      })

      return list
    },

    /*
    * get available tiers
    */
    async getAvailableTiers(eventCampaignId) {                
        var vm = this.vueInstance
        var response = (await useEventsService().getEventById(eventCampaignId)).data
        vm.availableTiers = []
        
        if (response && response.Events && response.Events.length > 0 && !vm.ignoreEventTiering) {
          // TODO: currently only takes the first one, needs to support different types
          if (
            response.Events[0].Tiers.length > 0 &&
            response.Events[0].Tiers[0].DisplaySettings &&
            response.Events[0].Tiers[0].DisplaySettings !== null &&
            typeof response.Events[0].Tiers[0].DisplaySettings === "object"
          )
            Object.assign(
                vm.defaultConfig,
                this._toCamelCase(
                    response.Events[0].Tiers[0].DisplaySettings
                )
            );
          vm.availableTiers = response.Events[0].Tiers
        } 
    },

    _toCamelCase(obj) {
        return _.transform(obj, (acc, value, key, target) => {
            const camelKey = _.isArray(target) ? key : _.camelCase(key);
            acc[camelKey] = _.isObject(value) ? this._toCamelCase(value) : value;
        });
    },
  }
}